/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React, {useState} from "react";
import PropTypes from "prop-types";
import GetStartedCta from "./GetStartedCta";
import {WealthyEnv} from "helpers";

const propTypes = {
  partnerData: PropTypes.object,
  rCode: PropTypes.string
};

const GetStartedCtaContainer = ({partnerData, rCode}) => {
  const [toggleModal, setToggleModal] = useState(false);

  const handleGetStarted = () => {
    if (partnerData?.name) {
      setToggleModal(true);
    } else {
      window.open(`${WealthyEnv.URL}/invest/stocks`, "_blank");
    }
  };

  return (
    <GetStartedCta
      partnerData={partnerData}
      rCode={rCode}
      setToggleModal={setToggleModal}
      toggleModal={toggleModal}
      handleGetStarted={handleGetStarted}
    />
  );
};

GetStartedCtaContainer.propTypes = propTypes;

export default GetStartedCtaContainer;
